import { View, Text, Pressable } from "react-native";
import styles from "./EspaceValideur.styles";
import { AffichagePeriode } from "../../components/AffichagePeriode/AffichagePeriode";
import { useCallback, useState } from "react";
import { DemandeStatus, ValidationCardProps } from "./EspaceValideur.types";
import ValideurDetailDemande from "./ValideurDetailDemande";

export default function ValidationCard({ demande, onValidate, onReject } : ValidationCardProps){
    const [status, setStatus] = useState<DemandeStatus>('');
    const handleOpenDetail = useCallback((type: string) => () => {
        setStatus(type as DemandeStatus);
    }, [])
    const handleCloseDetail = useCallback(() => setStatus(''),[])
    return(
        <>
            {status !== '' && (
                <ValideurDetailDemande
                    status={status}
                    demandeAbsence={demande}
                    onValidate={onValidate}
                    onReject={onReject}
                    onClose={handleCloseDetail}
                />
            )}
            <View style={styles.card}>
                <Pressable onPress={handleOpenDetail('info')}>
                    <View style={[styles.cardContent, {borderLeftColor: demande.natureAbsence?.couleurHexa}]}>
                        <Text style={styles.title}>{demande.agent?.nomClassement}</Text>
                        <AffichagePeriode dateDebut={demande.dateDebut} dateFin={demande.dateFin} style={styles.subtitle} />
                        <Text style={styles.subtitle}>{demande.duree?.texte}</Text>
                    </View>
                </Pressable>
                <View style={styles.buttonsRow}>
                    <Pressable style={styles.buttonAccept} onPress={handleOpenDetail('accept')}>
                        <Text style={styles.buttonText}>Valider</Text>
                    </Pressable>
                    <Pressable style={styles.buttonRefuse} onPress={handleOpenDetail('reject')}>
                        <Text style={styles.buttonText}>Refuser</Text>
                    </Pressable>
                </View>
            </View>
        </>
    )
}
